import React from "react";
import { Link } from "react-router-dom";
import Jumbotron from "../components/Jumbotron";
import SectionTitle from "../components/SectionTitle";
import CallToAction from "../components/CallToAction";
import OpportunityItem from "../components/opportunity-item";
import styles from "../styles/careers.module.scss";
import Button from "../components/Button";
import StudyWithUs from "../components/study-with-us";
import PageWrapper from "../components/PageWrapper";
import Helmet from "react-helmet";

const renderJobs = (jobs = []) => {
	return jobs.map(({ node }, i) => {
		if (node.slug !== "sample-entry") {
			return (
				<li key={"job-" + (i + 1)}>
					<OpportunityItem
						id={node.id}
						title={node.title}
						description={node.description.content.excerpt}
						location={node.jobLocation}
						url={`/${node.node_locale}/careers/${
							node.slug
						}-${node.id.substr(0, 20)}`}
						locale={node.node_locale}
					/>
				</li>
			);
		}
		return null;
	});
};

const Careers = ({ transition, data, location }) => {
	const { jobOpportunities, cta, pageSettings, bottomBanner } = data;

	const workWithUs = bottomBanner.edges[0].node;
	return (
		<PageWrapper
			locale={pageSettings.node_locale}
			location={location}
			data={data.layout.edges[0].node}
		>
			<main style={transition && transition.style} role="main">
			<Helmet title={pageSettings.pageTitle  + " | Mahidol Vivax Research Unit"} />
				<Jumbotron
					className="mb-0"
					textAlign="text-center"
					contentAlign="justify-content-md-center"
				>
					<h1>{pageSettings.pageTitle}</h1>
					<p>{pageSettings.metaDescription.metaDescription}</p>
				</Jumbotron>

				<div className="grey_bg">
					<div className="container py-5">
						{/* <SectionTitle
							title={
								pageSettings.node_locale === "th"
									? "โอกาสร่วมงาน"
									: "Career opportunities"
							}
							style={{ marginBottom: "1.5rem" }}
						/> */}
						<div className="row">
							<div className="col-12">
								{jobOpportunities.edges.length > 1 || jobOpportunities.edges[0].node.slug !== "sample-entry" ? (
									<ul className={styles.opportunities_list}>
										{renderJobs(jobOpportunities.edges)}
									</ul>
								) : (
									<div>
										<p className="text-center mb-0">
											
											{pageSettings.node_locale ===
													"th"
														? "ขณะนี้ยังไม่เปิดรับตำแหน่งงานใหม่"
														: "There are currently no job opportunities"}
										</p>
									</div>
								)}
							</div>
						</div>
					</div>
				</div>

				<CallToAction
					className="my-5"
					text={cta.edges[0].node.content.childMarkdownRemark.html}
					buttonLabel={cta.edges[0].node.buttonLabel}
					destination={`/${pageSettings.node_locale}${
						cta.edges[0].node.linkTo
					}`}
					arrow={true}
				/> 

				<StudyWithUs
					title={workWithUs.title}
					featuredImage={workWithUs.bannerImage}
					description={workWithUs.text.content.html}
				/>
			</main>
		</PageWrapper>
	);
};

export default Careers;

export const query = graphql`
	query CareersPageQuery($id: String!, $locale: String!) {
		layout: allMvruJson {
			edges {
				node {
					...layoutFields
				}
			}
		}

		pageSettings: contentfulCareersPage(id: { eq: $id }) {
			pageTitle
			metaDescription {
				metaDescription
			}
			node_locale
		}

		jobOpportunities: allContentfulJobOpportunity(
			filter: { node_locale: { eq: $locale } }
		) {
			edges {
				node {
					id
					title
					jobLocation
					slug
					node_locale
					description {
						content: childMarkdownRemark {
							excerpt(pruneLength: 200)
						}
					}
				}
			}
		}

		bottomBanner: allContentfulWhyWorkBanner(
			filter: { node_locale: { eq: $locale } }
		) {
			edges {
				node {
					id
					title
					text {
						content: childMarkdownRemark {
							html
						}
					}
					bannerImage {
						title
						sizes {
							base64
							aspectRatio
							src
							srcSet
							srcWebp
							srcSetWebp
							sizes
						}
					}
				}
			}
		}

		cta: allContentfulCallToAction(
			filter: {
				pageLocation: { eq: "careers" }
				node_locale: { eq: $locale }
			}
		) {
			edges {
				node {
					id
					pageLocation
					leadingText
					content {
						childMarkdownRemark {
							html
						}
					}
					linkTo
					buttonLabel
				}
			}
		}
	}
`;



// WEBPACK FOOTER //
// ./src/templates/careers-template.js